import React from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import { Icon } from '../../Common/Icon';

import cx from '../../../styles';

const AuthorInfoStripComponent = ({author, switchHandler, currentFeed, t, articleCount}) => {
    return (
        <div className={cx("author-info-strip-component")}>
            <div className={cx("shadow-card","author-info-strip-wrap")}>
                <div 
                    className={cx('info-wrap',currentFeed === 'posts' && 'active')} 
                    onClick={() => switchHandler('posts')}
                >
                    <div className={cx('tab')}>
                        <Icon name="posts-icon" />
                        <span>
                            {t('profile_tab_post')}({author.questions_asked})
                        </span>
                    </div>
                </div>

                <div 
                    className={cx('info-wrap',currentFeed == 'booth' && 'active')} 
                    onClick={(e) => {e.preventDefault(); switchHandler('booth')}}
                >
                    <div className={cx('tab')}>
                        <Icon name="photos-icon" />
                        <span>
                            <a href={`/user/${author.slug}#memories`} rel="nofollow" >{t('profile_tab_memories')}({author.booth_count})</a>
                        </span>
                    </div>
                </div>

                <div 
                    className={cx('info-wrap',currentFeed === 'replies' && 'active')} 
                    onClick={() => switchHandler('replies')}
                >
                    <div className={cx('tab')}>
                        <Icon name="reply-icon" />
                        <span>
                            {t('profile_tab_reply')}({author.answers_posted})
                        </span>
                    </div>
                </div>

                <div 
                    className={cx('info-wrap',currentFeed === 'articles' && 'active')} 
                    onClick={() => switchHandler('articles')}
                >
                    <div className={cx('tab')}>
                        <Icon name="articles-icon" />
                        <span>
                            {t('search_tab_article')}({articleCount})
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default translate()(AuthorInfoStripComponent);
